import './styles/App.css';

function Footer() {
  return (
    <div className="App-Footer">
      <p className='Footer-text'>Site développé par Alexia Cazade</p>
    </div>
  );
}

export default Footer;